import React, {FC, ReactNode} from 'react';
import {Animoji, AnimojiNames} from '../Animoji';

import styles from './Stub.module.css';

interface StubProps {
	message: ReactNode;
	emojiName: AnimojiNames;
	children?: ReactNode;
}

export const Stub: FC<StubProps> = ({message, emojiName, children}) => (
	<div>
		<div className={'grid place-items-center'}>
			<div className={styles.iconContainer}>
				<Animoji name={emojiName} className={styles.icon} />
			</div>

			<div className={styles.message}>{message}</div>

			{children}
		</div>
	</div>
);
